import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPeripheralProcessingConfigs, putPeripheralProcessingConfig } from 'services/api';
import { PeripheralProcessingConfig } from './interface';

export const getPeripheralProcessingConfigsAsync: any | null = createAsyncThunk(
  'peripheralProcessing/list',
  async () => {
    const response = await getPeripheralProcessingConfigs();
    return response?.data;
  },
);

/**
 * Guarda los modelos cambiados de uno en uno (el back tiene un PUT por modelo) y para en el primero
 * que falle, para que el aviso diga cuál. Devuelve los guardados y el fallo, si lo hubo; quien llama
 * avisa y recarga.
 */
export const putPeripheralProcessingConfigsAsync: any | null = createAsyncThunk(
  'peripheralProcessing/put',
  async (configs: PeripheralProcessingConfig[]) => {
    const saved: string[] = [];
    for (const config of configs) {
      const response = await putPeripheralProcessingConfig(config);
      if (!response?.data?.success) {
        return { saved, failed: { code: config.code, message: response?.data?.message } };
      }
      saved.push(config.code);
    }
    return { saved, failed: null };
  },
);
